import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'
import qs from 'qs'
import { toggleDefaultData } from './toggle'

const sample = {
  axios() {
    const AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL

    return AxiosInstance
  },
  getAllSamples(
    offset,
    limit,
    status,
    startDate,
    endDate,
    orderBy,
    q,
    dateType,
    patientName,
    batchLabel,
    codeOriginLis,
    codeOriginAlvaro,
    idFile,
    packagingType,
    integrated,
    docDelivered,
    processingOrigin,
    idRecollect,
    collectionPointName,
    printed,
    tab,
    sampleStatus,
    source
  ) {
    let endPoint = '/sample'
    if (tab === 'aolWs') endPoint += '/aolws'
    return this.axios().get(endPoint, {
      params: {
        limit,
        offset: offset * limit,
        status,
        startDate,
        endDate,
        orderBy,
        query: q,
        idRecollect: !isNaN(q) ? q : '',
        dateType,
        patientName,
        batchLabel,
        codeOriginLis,
        codeOriginAlvaro,
        idFile,
        packagingType,
        integrated,
        docDelivered,
        XmlOrder: getCookie('toggleAol').feature.sortByFile,
        processingOrigin,
        collectionPointName,
        XmlOrder: getCookie('toggleAol').feature.sortByFile,
        processingOrigin: processingOrigin,
        idRecollect: idRecollect,
        printed,
        sampleStatus,
        source,
        asyncBatch: getCookie('toggleAol').feature.nonSegregatedBatchList || false,
      },
      paramsSerializer(params) {
        return qs.stringify(params, {
          indices: false,
        })
      },
    })
  },
  getSampleByBarcode(barcode) {
    return this.axios().get(`/batch/batch-code?barcode=${barcode}`)
  },
  getSampleByBarcodeAOLWS(barcode) {
    return this.axios().get(`/batch/aolws/batch-code?barcode=${barcode}`)
  },
  printTag(sampleIds, printBatch, source) {
    if (source === 'AOLWS') {
      return this.axios().post('/sample/aolws/print', sampleIds)
    }
    return this.axios().post('/order/print', sampleIds, {
      params: {
        print_batch: printBatch,
      },
    })
  },
  printReceipt(items) {
    return this.axios().post('/report/sorted-order-transfer-receipt', items, {
      responseType: 'arraybuffer',
    })
  },
  countTotalSample(params) {
    const toggleData = toggleDefaultData()
    const headers = {
      asyncBatch: toggleData?.feature.nonSegregatedBatchList
    }

    return this.axios().post('/sample/samples-count', params, { headers })
  },
  aolwsSampleByBatch(id, filters) {
    return this.axios().get(`/sample/aolws/${id}`, { params: filters })
  },
  getPendingSamplesCounter() {
    return this.axios().get('/sample/samples-count-pending')
  },
}

export default sample
